!(function() {
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;
  const { max, min } = require('lodash/fp');

  var Handle = {
    top: 'TOP',
    left: 'LEFT',
    right: 'RIGHT',
    bottom: 'BOTTOM',
    topLeft: 'TOP_LEFT',
    topRight: 'TOP_RIGHT',
    bottomLeft: 'BOTTOM_LEFT',
    bottomRight: 'BOTTOM_RIGHT'
  };

  var EventName = {
    Resize: 'onResize',
    ResizeStart: 'onResizeStart',
    ResizeStop: 'onResizeStop'
  };

  function ResizableController(defaultX, defaultY, defaultWidth, defaultHeight, minConstraints, maxConstraints) {
    this.minConstraints = minConstraints;
    this.maxConstraints = maxConstraints;

    extendObservable(this, {
      width: defaultWidth,
      height: defaultHeight,
      slackWidth: 0,
      slackHeight: 0,
      x: defaultX,
      y: defaultY
    });
  }

  ResizableController.prototype.updatePosition = action(function updatePosition(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  });

  ResizableController.prototype.setWidthHeight = action(function setWidthHeight(width, height) {
    this.width = width;
    this.height = height;
  });

  ResizableController.prototype.setMinConstraints = action(function updatePosition(minConstraints) {
    this.minConstraints = minConstraints;
  });

  ResizableController.prototype.setMaxConstraints = action(function setWidthHeight(maxConstraints) {
    this.maxConstraints = maxConstraints;
  });

  ResizableController.prototype.resizeHandler = action(function resizeHandler(
    eventName,
    handle,
    dragData,
    resizeCallback
  ) {
    if (eventName === EventName.ResizeStart) {
      this.slackWidth = 0;
      this.slackHeight = 0;
    }

    var deltaX = detectChangeX(handle) ? -dragData.deltaX : dragData.deltaX;
    var deltaY = detectChangeY(handle) ? -dragData.deltaY : dragData.deltaY;

    var newWidth = this.width + deltaX;
    var newHeight = this.height + deltaY;
    var finalDim = this.runConstraints(newWidth, newHeight, handle);

    var widthChanged = this.width !== finalDim.width && detectChangeWidth(handle);
    var heightChanged = this.height !== finalDim.height && detectChangeHeight(handle);

    if (eventName === EventName.Resize && !widthChanged && !heightChanged) {
      return;
    }

    if (this.width !== finalDim.width && detectChangeWidth(handle)) {
      detectChangeX(handle) && (this.x += this.width - finalDim.width);
      this.width = finalDim.width;
    }
    if (this.height !== finalDim.height && detectChangeHeight(handle)) {
      detectChangeY(handle) && (this.y += this.height - finalDim.height);
      this.height = finalDim.height;
    }

    resizeCallback &&
      resizeCallback({
        left: this.x,
        top: this.y,
        width: this.width,
        height: this.height
      });
  });

  ResizableController.prototype.runConstraints = action(function runConstraints(width, height, side) {
    var oldWidth = width;
    var oldHeight = height;
    var slackWidth = this.slackWidth;
    var slackHeight = this.slackHeight;
    var mostRight = this.maxConstraints ? this.maxConstraints[0] : Infinity;
    var mostBottom = this.maxConstraints ? this.maxConstraints[1] : Infinity;
    var changeX = detectChangeX(side);
    var changeY = detectChangeY(side);
    var mostWidth = changeX ? this.x + this.width : mostRight - this.x;
    var mostHeight = changeY ? this.y + this.height : mostBottom - this.y;

    var maxWidth = mostRight === Infinity ? Infinity : mostWidth;
    var maxHeight = mostBottom === Infinity ? Infinity : mostHeight;

    if (!this.minConstraints && !this.maxConstraints) {
      return { width: width, height: height };
    }
    width += slackWidth;
    height += slackHeight;

    if (this.minConstraints) {
      width = max([this.minConstraints[0], width]);
      height = max([this.minConstraints[1], height]);
    }

    if (this.maxConstraints) {
      width = min([maxWidth, width]);
      height = min([maxHeight, height]);
    }

    this.slackWidth += oldWidth - width;
    this.slackHeight += oldHeight - height;

    return { width: width, height: height };
  });

  function detectChangeWidth(handle) {
    return /(LEFT|RIGHT)/g.test(handle);
  }
  function detectChangeHeight(handle) {
    return /(TOP|BOTTOM)/g.test(handle);
  }
  function detectChangeX(handle) {
    return /LEFT/g.test(handle);
  }
  function detectChangeY(handle) {
    return /TOP/g.test(handle);
  }

  ResizableController.Handle = Handle;

  ResizableController.EventName = EventName;

  module.exports = ResizableController;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ResizableController.js